import React from "react";

import "./progress.styles.css";

/**
 * @param {String} step: the position of the step progress 
 * @returns 
 */
const ProgressBar = ({step}) => {
  const styles =  step === 1 ? {width: `50%`} : {width: `100%`};
  return (
    <div className="progress__wrapper">
      <div className="progress__bar">
        <div className="progress__bar--count" style={styles}></div>
      </div>
      <span className="progress--step float--right">Step {step} of 2</span>
    </div>
  );
};

export default ProgressBar;
